<div class="section" style="width: 550px; height: 500px; flex: 1; display: flex; flex-direction: column;" data-cy="format-label-users-container">
    <div class="section-header" data-cy="format-label-users-header">
      <div class="section-header-title" data-cy="format-label-users-title">Select User</div>
    </div>
    <div class="section-content" style="display: flex; flex-direction: column; flex: 1;" data-cy="format-label-users-content">
         <div class="section-content" style="flex: 1; max-height: 400px; overflow-y: auto;" data-cy="format-label-users-table-container">
            <tdo-table #table [isAutoSelectFirstItem]="true"
            (rowSelected)="onRowSelected($event)" [dataSource]="newFormattedUserList" [isSearchable]="false" data-cy="format-label-users-table">
                <tdo-table-column displayName="User" propertyName="FullName" [rowTemplate]="FullName" data-cy="format-label-users-name-column">
                    <ng-template #FullName let-row>
                    <div data-cy="format-label-users-name-{{row.index}}">{{row.model.FirstName}} {{row.model.LastName}}</div>
                    </ng-template>
                </tdo-table-column>
            </tdo-table>
           </div>
        <div class="action-container" data-cy="format-label-users-actions">
        <button class="tdo-button tdo-save" style="margin-right: 12px;" (click)="createNewFormattedLabelUser()" data-cy="format-label-users-ok-button">OK</button>
        <button class="tdo-button tdo-close" style="margin-right: 12px;" (click)="cancel()" data-cy="format-label-users-close-button">Close</button>
      </div>
    </div>
  </div>
